import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FeedService } from '../../services/feed.service';
import { LoginService } from 'src/app/core/services/login.service';
import { PostnewJob } from 'src/app/modules/profile/services/job-section.service';
import { ToastService } from 'src/app/core/toast.service';
import { CommonServicesForAllModules } from 'src/app/shared/common/service';
import { Tables } from '../../../../shared/enum/tables.enum';

@Component({
  selector: 'app-add-job-role',
  templateUrl: './add-job-role.component.html',
  styleUrls: ['./add-job-role.component.scss']
})
export class AddJobRoleComponent implements OnInit {
 roleForm: FormGroup;
  roleId: string | null = null;
  roleName: any;
  
  constructor(private route: ActivatedRoute, private fb: FormBuilder, private router: Router, public feedService: FeedService, public loginService: LoginService,private commonService:CommonServicesForAllModules, private toast: ToastService) {
    this.roleForm = this.fb.group({
      role_name: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['roleName']) {
        this.roleForm.patchValue({ role_name: params['roleName'] });
      }
    });
    this.route.paramMap.subscribe(params => {
      this.roleId = params.get('id');
      // if (this.roleId) {
      //   this.loadCategoryDetails();
      // }
    });


  }
  // loadCategoryDetails() { }

  onSubmit(): void {

    if (this.roleForm.invalid) {
      this.roleForm.markAllAsTouched();  // This will show error messages
      return;  
    }


    const loginData = this.loginService.getLoginData();


    if (!loginData) {
      console.error('Login data is not available');
      return;
    }
    const roleData = {
      ...this.roleForm.value,
      created_by: loginData.type,
      created_by_user_id: loginData.id
    };
    const response = this.roleId ? this.commonService.UpdateData(Tables.Jobs_Role_List ,this.roleId, { role_name: this.roleForm.value.role_name }) :  this.commonService.InsertData(Tables.Jobs_Role_List,roleData);
    // const response = this.jobService.addRoles(roleData);
    response
      .then(response => {
        this.router.navigate(['/profile/job-role-listing']);
        this.toast.openSnackBar(this.roleId ? 'Role Updated successfully':'Role Added successfully'); 
      })
      .catch(error => {
        console.error("Error occurred:", error);
      });
  }


  onCancel(): void {
    this.router.navigate(['/profile/job-role-listing']);
  }
}